/* =====================================================
   JACKORA SHOPIFY THEME — theme.js
   Vanilla JS · No dependencies required
   ===================================================== */

(function () {
  'use strict';

  /* ─── Announcement Bar ──────────────────────────────── */
  const AnnouncementBar = {
    el: null,
    messages: [],
    index: 0,
    timer: null,

    init() {
      this.el = document.querySelector('[data-announcement-bar]');
      if (!this.el) return;

      const msgEls = this.el.querySelectorAll('[data-announcement-msg]');
      if (!msgEls.length) return;

      this.messages = Array.from(msgEls);
      this.showMessage(0);

      this.timer = setInterval(() => {
        this.index = (this.index + 1) % this.messages.length;
        this.showMessage(this.index);
      }, 4500);

      const prevBtn = this.el.querySelector('[data-ann-prev]');
      const nextBtn = this.el.querySelector('[data-ann-next]');
      if (prevBtn) prevBtn.addEventListener('click', () => this.navigate(-1));
      if (nextBtn) nextBtn.addEventListener('click', () => this.navigate(1));
    },

    navigate(dir) {
      clearInterval(this.timer);
      this.index = (this.index + dir + this.messages.length) % this.messages.length;
      this.showMessage(this.index);
      this.timer = setInterval(() => {
        this.index = (this.index + 1) % this.messages.length;
        this.showMessage(this.index);
      }, 4500);
    },

    showMessage(i) {
      this.messages.forEach((msg, idx) => {
        msg.style.display = idx === i ? 'flex' : 'none';
      });
    }
  };

  /* ─── Header Scroll ─────────────────────────────────── */
  const Header = {
    el: null,

    init() {
      this.el = document.querySelector('.site-header');
      if (!this.el) return;

      const check = () => {
        if (window.scrollY > 24) {
          this.el.classList.add('is-scrolled');
        } else {
          this.el.classList.remove('is-scrolled');
        }
      };
      check();
      window.addEventListener('scroll', check, { passive: true });
    }
  };

  /* ─── Mobile Menu ───────────────────────────────────── */
  const MobileMenu = {
    menu: null,
    overlay: null,
    openBtn: null,
    closeBtn: null,

    init() {
      this.menu = document.querySelector('.mobile-menu');
      this.overlay = document.querySelector('.mobile-menu-overlay');
      this.openBtn = document.querySelector('[data-menu-open]');
      this.closeBtn = document.querySelector('[data-menu-close]');
      if (!this.menu) return;

      if (this.openBtn) this.openBtn.addEventListener('click', () => this.open());
      if (this.closeBtn) this.closeBtn.addEventListener('click', () => this.close());
      if (this.overlay) this.overlay.addEventListener('click', () => this.close());

      document.querySelectorAll('.mobile-nav__link').forEach(link => {
        link.addEventListener('click', () => this.close());
      });

      document.addEventListener('keydown', e => {
        if (e.key === 'Escape') this.close();
      });
    },

    open() {
      this.menu.classList.add('is-open');
      if (this.overlay) this.overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      this.menu.setAttribute('aria-hidden', 'false');
    },

    close() {
      this.menu.classList.remove('is-open');
      if (this.overlay) this.overlay.classList.remove('is-open');
      document.body.style.overflow = '';
      this.menu.setAttribute('aria-hidden', 'true');
    }
  };

  /* ─── Mega Menu ─────────────────────────────────────── */
  const MegaMenu = {
    trigger: null,
    menu: null,
    closeTimer: null,

    init() {
      this.trigger = document.querySelector('[data-mega-trigger]');
      this.menu = document.querySelector('.mega-menu');
      const header = document.querySelector('.site-header');
      if (!this.trigger || !this.menu) return;

      this.trigger.addEventListener('mouseenter', () => this.open());
      this.menu.addEventListener('mouseenter', () => clearTimeout(this.closeTimer));

      if (header) {
        header.addEventListener('mouseleave', () => this.scheduledClose());
      }
      this.menu.addEventListener('mouseleave', () => this.scheduledClose());

      this.trigger.addEventListener('focus', () => this.open());
    },

    open() {
      clearTimeout(this.closeTimer);
      this.menu.classList.add('is-open');
    },

    scheduledClose() {
      this.closeTimer = setTimeout(() => this.close(), 150);
    },

    close() {
      this.menu.classList.remove('is-open');
    }
  };

  /* ─── Search Bar ────────────────────────────────────── */
  const SearchBar = {
    bar: null,
    input: null,
    toggleBtn: null,
    closeBtn: null,

    init() {
      this.bar = document.querySelector('.search-bar');
      this.input = document.querySelector('.search-bar__input');
      this.toggleBtn = document.querySelector('[data-search-toggle]');
      this.closeBtn = document.querySelector('[data-search-close]');
      if (!this.bar) return;

      if (this.toggleBtn) {
        this.toggleBtn.addEventListener('click', () => this.toggle());
      }
      if (this.closeBtn) {
        this.closeBtn.addEventListener('click', () => this.close());
      }

      document.addEventListener('keydown', e => {
        if (e.key === 'Escape') this.close();
      });
    },

    toggle() {
      const isOpen = this.bar.classList.contains('is-open');
      if (isOpen) { this.close(); } else { this.open(); }
    },

    open() {
      this.bar.classList.add('is-open');
      if (this.input) setTimeout(() => this.input.focus(), 100);
    },

    close() {
      this.bar.classList.remove('is-open');
    }
  };

  /* ─── FAQ Accordion ─────────────────────────────────── */
  const FaqAccordion = {
    init() {
      const buttons = document.querySelectorAll('.faq-question');
      buttons.forEach((btn, i) => {
        const answer = btn.nextElementSibling;
        if (!answer) return;

        // Open first by default
        if (i === 0) {
          btn.setAttribute('aria-expanded', 'true');
          answer.classList.add('is-open');
        }

        btn.addEventListener('click', () => {
          const expanded = btn.getAttribute('aria-expanded') === 'true';
          // Close all
          buttons.forEach(b => {
            b.setAttribute('aria-expanded', 'false');
            const a = b.nextElementSibling;
            if (a) a.classList.remove('is-open');
          });
          // Toggle clicked
          if (!expanded) {
            btn.setAttribute('aria-expanded', 'true');
            answer.classList.add('is-open');
          }
        });
      });
    }
  };

  /* ─── Scroll Reveal ─────────────────────────────────── */
  const ScrollReveal = {
    observer: null,

    init() {
      if (!('IntersectionObserver' in window)) {
        document.querySelectorAll('.fade-in').forEach(el => el.classList.add('is-visible'));
        return;
      }

      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry, i) => {
          if (entry.isIntersecting) {
            const delay = entry.target.dataset.delay || 0;
            setTimeout(() => {
              entry.target.classList.add('is-visible');
            }, delay * 1000);
            this.observer.unobserve(entry.target);
          }
        });
      }, { rootMargin: '-60px 0px', threshold: 0.1 });

      document.querySelectorAll('.fade-in').forEach(el => this.observer.observe(el));
    }
  };

  /* ─── Newsletter Form ───────────────────────────────── */
  const NewsletterForm = {
    init() {
      const forms = document.querySelectorAll('[data-newsletter-form]');
      forms.forEach(form => {
        form.addEventListener('submit', e => {
          e.preventDefault();
          const input = form.querySelector('[data-newsletter-email]');
          const success = form.closest('[data-newsletter-wrap]')?.querySelector('[data-newsletter-success]');
          const errorEl = form.querySelector('[data-newsletter-error]');

          if (!input) return;
          const email = input.value.trim();
          const valid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

          if (!valid) {
            if (errorEl) { errorEl.style.display = 'block'; }
            return;
          }
          if (errorEl) errorEl.style.display = 'none';

          // Simulate success (Shopify handles actual submission via Customers API)
          if (success) {
            form.style.display = 'none';
            success.style.display = 'inline-flex';
          }
        });
      });
    }
  };

  /* ─── Contact Form ──────────────────────────────────── */
  const ContactForm = {
    init() {
      const form = document.querySelector('[data-contact-form]');
      if (!form) return;

      form.addEventListener('submit', e => {
        e.preventDefault();
        let valid = true;

        form.querySelectorAll('[data-required]').forEach(field => {
          const errorEl = form.querySelector(`[data-error="${field.name}"]`);
          if (!field.value.trim()) {
            if (errorEl) errorEl.textContent = `Please enter your ${field.name}.`;
            field.classList.add('form-input--error');
            valid = false;
          } else if (field.type === 'email' && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(field.value)) {
            if (errorEl) errorEl.textContent = 'Please enter a valid email address.';
            field.classList.add('form-input--error');
            valid = false;
          } else {
            if (errorEl) errorEl.textContent = '';
            field.classList.remove('form-input--error');
          }
        });

        if (!valid) return;

        // Let Shopify handle the real submission
        form.submit();
      });
    }
  };

  /* ─── Product Gallery ───────────────────────────────── */
  const ProductGallery = {
    init() {
      const thumbs = document.querySelectorAll('.product-gallery__thumb');
      const mainImg = document.querySelector('.product-gallery__main img');
      if (!thumbs.length || !mainImg) return;

      thumbs.forEach(thumb => {
        thumb.addEventListener('click', () => {
          const thumbImage = thumb.querySelector('img');
          const src = thumb.dataset.fullImage || thumbImage?.src;
          if (!src) return;
          mainImg.src = src;
          mainImg.removeAttribute("srcset");
          mainImg.alt = thumbImage?.alt || mainImg.alt;
          thumbs.forEach(t => t.classList.remove('is-active'));
          thumb.classList.add('is-active');
        });
      });

      // Activate first thumb
      if (thumbs[0] && !Array.from(thumbs).some(thumb => thumb.classList.contains('is-active'))) thumbs[0].classList.add('is-active');
    }
  };

  /* ─── Cart Drawer (stub — Shopify handles real cart) ── */
  const CartIcon = {
    init() {
      document.querySelectorAll('[data-add-to-cart]').forEach(btn => {
        btn.addEventListener('click', function () {
          const variantId = this.dataset.variantId;
          if (!variantId) return;

          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: variantId, quantity: 1 })
          })
            .then(r => r.json())
            .then(() => {
              // Update cart count badge
              fetch('/cart.js')
                .then(r => r.json())
                .then(cart => {
                  document.querySelectorAll('[data-cart-count]').forEach(el => {
                    el.textContent = cart.item_count;
                    el.style.display = cart.item_count > 0 ? 'flex' : 'none';
                  });
                });
            })
            .catch(console.error);
        });
      });
    }
  };

  /* ─── Review Helpful ────────────────────────────────── */
  const ReviewHelpful = {
    init() {
      document.querySelectorAll('[data-helpful-btn]').forEach(btn => {
        btn.addEventListener('click', function () {
          const countEl = this.querySelector('[data-helpful-count]');
          const isActive = this.classList.toggle('is-active');
          if (countEl) {
            const current = parseInt(countEl.textContent, 10);
            countEl.textContent = isActive ? current + 1 : current - 1;
          }
        });
      });
    }
  };

  /* ─── Review Bars Animation ─────────────────────────── */
  const ReviewBars = {
    init() {
      if (!('IntersectionObserver' in window)) return;
      const bars = document.querySelectorAll('.review-bar__fill');
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const pct = entry.target.dataset.percent || '0';
            entry.target.style.width = pct + '%';
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.3 });
      bars.forEach(bar => { bar.style.width = '0%'; observer.observe(bar); });
    }
  };

  /* ─── Currency Selector ─────────────────────────────── */
  const CurrencySelector = {
    init() {
      const selects = document.querySelectorAll('[data-currency-select]');
      selects.forEach(select => {
        select.addEventListener('change', function () {
          // Shopify Markets handles currency conversion
          const form = this.closest('form');
          if (form) form.submit();
        });
      });
    }
  };

  /* ─── Collection Filter ─────────────────────────────── */
  const CollectionFilter = {
    init() {
      document.querySelectorAll('[data-filter-form]').forEach(form => {
        const applyFilters = () => {
          const url = new URL(window.location.href);
          for (const key of Array.from(url.searchParams.keys())) {
            if (key.startsWith('filter.') || key === 'page') url.searchParams.delete(key);
          }
          for (const [key, value] of new FormData(form)) {
            if (String(value).trim() !== '') url.searchParams.append(key, value);
          }
          window.location.assign(url.toString());
        };
        form.addEventListener('submit', event => {
          event.preventDefault();
          applyFilters();
        });
        form.querySelectorAll('[data-filter-option]').forEach(option => {
          option.addEventListener('change', applyFilters);
        });
      });
    }
  };

  /* ─── Smooth Scroll ─────────────────────────────────── */
  const SmoothScroll = {
    init() {
      document.querySelectorAll('a[href^="#"]').forEach(anchor => {
        anchor.addEventListener('click', function (e) {
          const target = document.querySelector(this.getAttribute('href'));
          if (target) {
            e.preventDefault();
            target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        });
      });
    }
  };

  /* ─── Init All ──────────────────────────────────────── */
  document.addEventListener('DOMContentLoaded', () => {
    AnnouncementBar.init();
    Header.init();
    MobileMenu.init();
    MegaMenu.init();
    SearchBar.init();
    FaqAccordion.init();
    ScrollReveal.init();
    NewsletterForm.init();
    ContactForm.init();
    ProductGallery.init();
    CartIcon.init();
    ReviewHelpful.init();
    ReviewBars.init();
    CurrencySelector.init();
    CollectionFilter.init();
    SmoothScroll.init();
  });

})();
